import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Dropdown, Header } from 'semantic-ui-react';
import { fetchM } from '../../../actions/fetchM';
import { flashErrorMessage } from '../../../actions/flash';
import config from '../../../../config';

const dropdownStyle = {
  margin: 0,
};

export default class BusinessUnitDropdown extends Component {
  static propTypes = {
    onChange: PropTypes.func.isRequired,
    value: PropTypes.oneOfType([PropTypes.array]).isRequired,
  }
  static contextTypes = {
    store: PropTypes.object,
  }
  static getPropsToState = (props) => {
    const value = props.value || [];
    return {
      value,
    };
  }
  constructor(props) {
    super(props);
    const state = BusinessUnitDropdown.getPropsToState(props);
    this.state = {
      ...state,
      branches: [],
      fullBranches: [],
      loading: true,
      value: props.value ? props.value : [],
    };
  }
  componentDidMount() {
    this.fetchCompanyBranches();
  }
  componentWillReceiveProps(nextProps) {
    const state = BusinessUnitDropdown.getPropsToState(nextProps);
    this.setState({ ...state });
  }
  setComponentState(state = {}, callback) {
    return new Promise((res) => {
      this.setState(state, () => {
        if (callback) {
          callback();
        }
        res(state);
      });
    });
  }
  setLoading(loading = false) {
    return new Promise((res) => {
      this.setState({ loading }, () => {
        res(loading);
      });
    });
  }
  async fetchCompanyBranches() {
    const { store } = this.context;
    let res;
    try {
      res = await store.dispatch(fetchM(`${config.get('bookApiURL')}/company_branches/?page=all&getProjects=true`, {
        credentials: 'include',
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      }));
    } catch (e) {
      await this.setLoading(false);
      Bugsnag.notifyException(e);
      await store.dispatch(flashErrorMessage({ message: 'An error occurred, please refresh page' }));
      return;
    }
    if (!res.ok) {
      await this.setLoading(false);
      const message = await res.text();
      await store.dispatch(flashErrorMessage({ message }));
    } else {
      const branches = await res.json();
      await this.setComponentState({
        branches: branches ? branches.map((ul) => {
          const branch = {
            content: <Header as="h5" style={dropdownStyle} content={ul.shortName} subheader={ul.name} />,
            description: ul.isExternal ? 'Agency' : '',
            key: ul.id,
            name: ul.shortName,
            text: ul.shortName,
            value: ul.id,
          };
          return branch;
        }) : [],
        fullBranches: branches,
      });
      await this.setLoading(false);
    }
  }
  handleOnChange = (e, { value }) => {
    if (this.props.onChange) {
      this.props.onChange(value);
    }
  }
  render() {
    const {
      branches,
      loading,
      value,
    } = this.state;
    return (
      <div>
        <div className="label_bu_access">Business Unit Access</div>
        <Dropdown
          fluid
          loading={loading}
          multiple
          onChange={this.handleOnChange}
          options={branches}
          search
          selection
          placeholder="Select Business Unit Access"
          value={value}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Sortable/SortablePackagePricing/BusinessUnitDropdown.jsx